import { IMAGE_FILE } from '@shoflo/polymer';
import { BACKGROUND_ADD } from 'store/eventConstants';
import { BROADCAST_CREATE_BACKGROUND } from 'actions/Types';
import { withCurrentParams, mapSignedUrlsToSources } from 'actions/utils';
import { FILL_FRAME, BackgroundStyles } from 'constants/LayerPositions';

export default (eventDoc, template) => {
  return withCurrentParams(
    (dispatch, { teamId, eventId, broadcastId }, _, socket) => {
      const action = {
        type: BROADCAST_CREATE_BACKGROUND,
        request: async apiClient => {
          const payload = {
            source: {
              type: IMAGE_FILE,
              title: template.title,
              value: eventDoc._id
            },
            layer: {
              title: FILL_FRAME,
              style: BackgroundStyles[FILL_FRAME]
            }
          };
          const broadcast = await apiClient.broadcast.createBackground(
            teamId,
            eventId,
            broadcastId,
            payload
          );
          const { backgrounds } = broadcast;
          const createdBackground = backgrounds.find(
            background => background.source.value === eventDoc._id
          );
          const mappedBackground = await mapSignedUrlsToSources(
            [createdBackground],
            apiClient,
            teamId,
            eventId
          );
          // notify other directors
          socket.emit(BACKGROUND_ADD, { broadcastId });
          return mappedBackground;
        }
      };
      dispatch(action);
    }
  );
};
